import script from "./AccountInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccountInfo.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__